import { z } from "zod";

export function parseFormValidation(field: any) {
  const { type, optional, validations, label } = field;

  let schema: any;

  switch (type) {
    case "string":
    case "radio":
      schema = z.string();
      break;
    case "number":
    case "bigint":
      schema = z.number();
      break;
    case "boolean":
      schema = z.boolean();
      break;
    default:
      schema = z.any();
  }

  if (typeof validations === "string" && validations.length > 0) {
    const rules = validations.split("|");

    rules.forEach((rule: string) => {
      if (rule.startsWith("min:")) {
        const value = Number(rule.split(":")[1]);
        if (!isNaN(value)) schema = schema.min(value, `${label} tidak boleh kurang dari ${value} ${type === "number" ? "digit" : "karakter"}`);
        return;
      }

      if (rule.startsWith("max:")) {
        const value = Number(rule.split(":")[1]);
        if (!isNaN(value)) schema = schema.max(value, `${label} tidak boleh lebih dari ${value} ${type === "number" ? "digit" : "karakter"}`);
        return;
      }

      if (rule.startsWith("length:")) {
        const value = Number(rule.split(":")[1]);
        if (!isNaN(value)) schema = schema.length(value, `Panjang karakter ${label} tidak boleh kurang dari ${value}`);
        return;
      }

      if (rule.startsWith("regex:")) {
        const raw = rule.replace("regex:", "").trim();
        const regex = new RegExp(raw);

        schema = schema.regex(regex, `Format ${label} tidak tepat`);

        return;
      }

      if (rule === "email") {
        schema = schema.email(`Format ${label} tidak tepat`);
        return;
      }

      if (rule.startsWith("startsWith:")) {
        const text = rule.replace("startsWith:", "");
        schema = schema.startsWith(text, `${label} harus dimulai dengan karakter: ${text}`);
        return;
      }

      if (rule.startsWith("endsWith:")) {
        const text = rule.replace("endsWith:", "");
        schema = schema.endsWith(text, `${label} harus diakhiri dengan karakter: ${text}`);
        return;
      }

      if (rule.startsWith("includes:")) {
        const text = rule.replace("includes:", "");
        schema = schema.includes(text, `${label} harus mengandung karakter: ${text}`);
        return;
      }

      if (rule === "lowercase") {
        schema = schema.toLowerCase(`${label} harus huruf kecil`);
        return;
      }

      if (rule === "uppercase") {
        schema = schema.toUpperCase(`${label} harus huruf besar`);
        return;
      }
    });
  }

  if (optional) {
    schema = schema.optional();
  }

  return schema;
}

export function buildFormSchema(fields: any[]) {
  const shape: any = {};

  fields.forEach((field) => {
    const key = field.name;
    shape[key] = parseFormValidation(field);
  });

  return z.object(shape);
}